<template>
  <div class="wrap-lg">
    <el-header>
      <div class="wrap-lg">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>个人中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{pathTittle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </el-header>
    <el-container style="margin-bottom: 30px">
      <el-aside width="220px">
        <el-menu style="min-height: 516px;padding-top: 6px;border-radius: 6px;"
          :default-active="defaultActive"
          router collapse-transition unique-opened
          background-color="#efefef"
          text-color="#858585"
          active-text-color="#32A08C">
          <el-menu-item index="/userCenter/myCenter" style="text-align: center;border-bottom: solid 2px #32A08C ">
            <span slot="title">你好，<span v-if="isLogin">{{userInfo.account}}</span></span>
          </el-menu-item>
          <el-submenu index="/entrust">
            <template slot="title"><i class="iconfont icon-weituoshezhi" style="margin: 0 8px 0 5px;"></i>委托管理</template>
            <el-menu-item index="/userCenter/myEntrust">我的委托</el-menu-item>
            <el-menu-item index="/userCenter/myEnterpriseStandard">我的企标</el-menu-item>
            <el-menu-item index="/userCenter/myReport">报告管理</el-menu-item>
            <el-menu-item index="/userCenter/myEntrustCount">委托统计</el-menu-item>
          </el-submenu>
          <el-submenu index="/userCenter/order">
            <template slot="title"><i class="el-icon-s-order"></i>订单管理</template>
            <el-menu-item index="/userCenter/myOrder">我的订单</el-menu-item>
          </el-submenu>
          <el-menu-item index="/userCenter/vipLevel">
            <i class="iconfont icon-huiyuan1" style="margin: 0 7px 0 3px;"></i>
            <span slot="title">会员等级</span>
          </el-menu-item>
          <el-submenu index="2-4">
            <template slot="title"><i class="el-icon-setting"></i>资料设置</template>
            <el-menu-item index="/userCenter/userInfo">客户信息</el-menu-item>
            <el-menu-item index="/userCenter/myContact">联络人</el-menu-item>
            <el-menu-item index="/userCenter/myInvoice">发票抬头</el-menu-item>
            <el-menu-item index="/userCenter/myAddress">收货地址</el-menu-item>
            <el-menu-item index="/userCenter/manufacturer">生产单位</el-menu-item>
            <el-menu-item index="/userCenter/stuffManage">员工账号</el-menu-item>
            <el-menu-item index="/userCenter/updatePassword">修改密码</el-menu-item>
          </el-submenu>
          <el-menu-item v-if="(companyInfo && !companyInfo.parentId && isManager)" index="/userCenter/myOrg">
            <i class="el-icon-office-building"></i>
            <span slot="title">机构管理</span>
          </el-menu-item>
         <!-- <el-menu-item index="/userCenter/myMessage">
            <i class="el-icon-message"></i>
            <span slot="title">消息通知</span>
          </el-menu-item>-->
          <el-menu-item index="/userCenter/myBill">
            <i class="el-icon-document"></i>
            <span slot="title">我的账单</span>
          </el-menu-item>
          <!--<el-menu-item index="/myReport">-->
            <!--<i class="el-icon-document"></i>-->
            <!--<span slot="title">统计分析</span>-->
          <!--</el-menu-item>-->
          <!--<el-menu-item index="/myOrder" disabled="true">-->
            <!--<i class="el-icon-document"></i>-->
            <!--<span slot="title">我的订单</span>-->
          <!--</el-menu-item>-->
        </el-menu>
      </el-aside>
      <el-main style="padding: 0 20px 40px 20px">
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      defaultActive: '',
      isManager: false,
      pathTittle: ''
    }
  },
  mounted () {
    if (this.userInfo && this.userInfo.isManager === '0') {
      this.isManager = true
    } else {
      this.isManager = false
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    },
    companyInfo () {
      return this.$store.state.user.companyInfo
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    vipInfo () {
      return this.$store.state.user.vipInfo
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        const { path } = route
        this.defaultActive = path
        this.pathTittle = route.meta.title
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-tittle{
  font-size: 16px;
  color: #303133;
  padding-left: 20px;
  padding: 0 20px;
  font-weight: 500;
}
</style>
